import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUndertaleComponent } from './simple-icons-undertale.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUndertaleComponent ],
    exports:      [ SimpleIconsUndertaleComponent ],
    bootstrap:    []
})
export class SimpleIconsUndertaleModule {}
